export default "__VITE_ASSET__bzL0$xTf__"